import styled from "styled-components";

export const Container = styled.p`
  color: #333;
  font-size: 0.938rem;
  line-height: 150%;

  margin-bottom: ${(props) => props.mb || "0.5rem"};
`;
